import { Typography } from "@mui/material";
import { GridText } from "./GridText";
import { JsonAttributeType } from "src/api/client-api/jsonAttributes/useJsonAttribute";
import type { ComponentAppearance } from "src/components/appearance";

type GridJsonAttributeProps = {
    value: any;
    attributeType: JsonAttributeType;
    appearance?: ComponentAppearance;
};

export const GridJsonAttribute = ({ value, attributeType, appearance = "legacy" }: GridJsonAttributeProps) => {
    if (value === null || value === undefined) {
        return <GridText value="-" appearance={appearance} />;
    }

    // Handle boolean values
    if (attributeType === JsonAttributeType.BOOLEAN) {
        return (
            <Typography variant="body2" sx={{ color: value ? "success.main" : "text.secondary" }}>
                {value ? "Oui" : "Non"}
            </Typography>
        );
    }

    // Handle numeric values with proper formatting
    if (attributeType === JsonAttributeType.INTEGER || attributeType === JsonAttributeType.FLOAT) {
        const numericValue = Number(value);
        if (isNaN(numericValue)) {
            return <GridText value="-" appearance={appearance} />;
        }

        const formattedValue =
            attributeType === JsonAttributeType.FLOAT ?
                numericValue.toLocaleString("fr-FR", { maximumFractionDigits: 2 })
            :   numericValue.toLocaleString("fr-FR");

        return <GridText value={formattedValue} appearance={appearance} />;
    }

    // Handle string values and fallback
    return <GridText value={String(value)} appearance={appearance} />;
};
